
import { NavigationModel } from '../../../navigation.model';

/**
* @author Camilo
* @since  09/11/2017
**/
export class InfoSesion{
	
	public formularioActivo:string;
	public nombreFormularioActual:string;

	constructor(public model: NavigationModel, public token:string, public contratos:string[], public usuario:string){}
	
}


// WEBPACK FOOTER //
// D:/REPO/FacturacionWeb/src/app/main/content/Global/InfoSesion.model.ts